import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RoleId } from '@/types/roles';
import { useAuth } from '@store/hooks/useAuth.ts';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: RoleId;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
}) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    requiredRole &&
    user.role !== requiredRole &&
    user.role !== RoleId.ADMINISTRATOR
  ) {
    return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
